import React from "react"
import { FormattedMessage, } from "react-intl"
import { StatusBadge } from "../../../common/badge"
import { StockDocumentTimelineProps } from "../../../common/types/timeline"

const StockDocumentCompletedComponent = (props: StockDocumentTimelineProps) => {

    const completedStatus = props.stockDocument?.attributes.definition?.attributes.statuses?.find(status => status.attributes.state === "completed")

    return <div className={"row"}>
        <div className="col-12"
            data-document-event="stock-document-completed"
            data-document-direction={props.stockDocument.attributes.definition.attributes.direction.toLowerCase()} >
            <FormattedMessage
                id="quote.events.stock_document_completed.text"
                defaultMessage="{document} {identifier} has been"
                values={{
                    document: props.stockDocument.attributes.definition.attributes.name,
                    identifier: props.stockDocument.attributes.identifier
                }}
            />
            &nbsp;
            {completedStatus ?
                <StatusBadge
                    colorCode={completedStatus?.attributes.colorCode}
                    text={completedStatus.attributes.name}
                /> :
                <FormattedMessage
                    id="quote.events.stock_document_completed.text_completed"
                    defaultMessage="completed"
                />
            }
        </div>
    </div>
}

export default StockDocumentCompletedComponent








// WEBPACK FOOTER //
// ./src/quote/analytics/events/stock-document-completed.component.tsx